import { Base } from './base';

export class ParkingTariff extends Base {
    ParkingTariffID: number;
    ParkingID: number;
    TarriffID: number;
    AuthorID: string;
    Date: Date;

    //Model properties
    TariffType: string;
    Price: string;
    Tariff: number;
}